module.exports = __webpack_public_path__ + "media/logos/abajournal-logo-white-589edd17.png";